import React from 'react';
import { gql, useQuery } from '@apollo/client';
import { Datagrid, DateInput } from 'react-admin';
import List from 'components/List';
import PositionInput from 'components/PositionInput';
import LinkField from 'components/LinkField';
import DateTimeField from 'components/DateTimeField';
import { getSettingsQuery } from '../utils/getSettingsQuery';
import { IdFilter } from 'components/Filter';
import RateSettingsBulkUploadActions from '../shared/RateSettingsBulkUploadActions';

const TEMPLATE_URL_QUERY = gql`
  query {
    locationPositionRateSettingTemplateUrl
  }
`;

const LocationPositionRateSettingListFilters = [
  <IdFilter />,
  <IdFilter label="Location ID" source="location_id" alwaysOn />,
  <PositionInput emptyText="All" alwaysOn />,
  <DateInput alwaysOn label="Updated after" source="search.updated_at_from" />,
];

const LocationPositionRateSettingList = () => {
  const { data: templateUrlData } = useQuery(TEMPLATE_URL_QUERY);
  const downloadUrl = templateUrlData?.locationPositionRateSettingTemplateUrl ?? '';

  return (
    <List
      filters={LocationPositionRateSettingListFilters}
      exporter={false}
      additionalActions={
        <RateSettingsBulkUploadActions
          accessResource="LocationPositionRateSetting"
          downloadUrl={downloadUrl}
          uploadUrl="v3/admin/location_position_rate_settings/import"
        />
      }
      filter={{ active: true }}
    >
      <Datagrid bulkActionButtons={false}>
        <LinkField label="ID" source="id" />
        <LinkField label="Location ID" source="location_id" />
        <LinkField label="Position" source="position.display_name" sortBy="position_name" />
        <LinkField label="Specialty" source="specialty.label" sortBy="specialty_name" />
        <DateTimeField
          format="MM/dd/yyyy HH:mm"
          source="updated_at"
          timeZone="America/Los_Angeles"
        />
      </Datagrid>
    </List>
  );
};

LocationPositionRateSettingList.query = gql`
  query locationPositionRateSettings($input: LocationPositionRateSettingQueryInput) {
    _locationPositionRateSettingsMeta(input: $input) {
      count
    }
    locationPositionRateSettings(input: $input) {
      id
      active
      location_id
      location_position_rate_setting_active
      location_position_rate_setting_id
      market_position_rate_setting_active
      market_position_rate_setting_id
      position {
        id
        display_name
      }
      location {
        primary_billing_group {
          plan
        }
      }
      position_id
      ${getSettingsQuery(true)}
      specialty {
        id
        label
      }
      specialty_id
      state_position_rate_setting_active
      state_position_rate_setting_id
      updated_at
    }
  }
`;

export default LocationPositionRateSettingList;
